import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createSlots as _createSlots, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
  style: {
    "display": "flex",
    "justify-content": "center",
    "align-items": "center",
    "width": "100%",
    "min-width": "270px",
    "align-self": "stretch",
    "height": "25px"
  }
};
const _hoisted_6 = {
  class: "share-of-voice-sublabel"
};
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = {
  class: "product-popover-content"
};
const _hoisted_10 = {
  class: "title-details"
};
const _hoisted_11 = {
  class: "title-asin"
};
const _hoisted_12 = {
  class: "title"
};
const _hoisted_13 = {
  class: "price-ratings"
};
const _hoisted_14 = {
  class: "price"
};
const _hoisted_15 = {
  class: "ratings"
};
const _hoisted_16 = {
  class: "sf-share-of-voice-popover-content"
};
const _hoisted_17 = {
  class: "title-table-header"
};
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", {
  class: "table-header"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "key"
}, "ASIN"), /*#__PURE__*/_createElementVNode("div", {
  class: "attribute"
}, "Freq."), /*#__PURE__*/_createElementVNode("div", {
  class: "attribute"
}, "Best")], -1);
const _hoisted_19 = {
  class: "body"
};
const _hoisted_20 = {
  class: "image-name-asin"
};
const _hoisted_21 = {
  class: "name-asin"
};
const _hoisted_22 = {
  class: "asin"
};
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", {
  class: "bar-background",
  style: {
    flex: '1 0 0',
    borderRadius: '4px',
    height: '4px',
    background: '#E8EBF3'
  }
}, null, -1);
const _hoisted_24 = {
  class: "product-popover-content"
};
const _hoisted_25 = {
  class: "title-details"
};
const _hoisted_26 = {
  class: "title-asin"
};
const _hoisted_27 = {
  class: "title"
};
const _hoisted_28 = {
  class: "price-ratings"
};
const _hoisted_29 = {
  class: "price"
};
const _hoisted_30 = {
  class: "ratings"
};
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", {
  class: "bar-background",
  style: {
    flex: '1 0 0',
    borderRadius: '4px',
    height: '4px',
    background: '#E8EBF3'
  }
}, null, -1);
const _hoisted_32 = {
  class: "product-popover-content impression-share"
};
const _hoisted_33 = {
  class: "impression-share-title-date"
};
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "#impressions per search", -1);
const _hoisted_35 = {
  class: "impression-share-details"
};
const _hoisted_36 = {
  class: "detail-row"
};
const _hoisted_37 = {
  class: "dot-key"
};
const _hoisted_38 = {
  class: "values"
};
const _hoisted_39 = {
  class: "product-popover-content impression-share"
};
const _hoisted_40 = {
  class: "impression-share-title-date"
};
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "Click distribution", -1);
const _hoisted_42 = {
  class: "impression-share-details"
};
const _hoisted_43 = {
  class: "detail-row"
};
const _hoisted_44 = {
  class: "dot-key"
};
const _hoisted_45 = {
  class: "values"
};
const _hoisted_46 = {
  class: "currencies"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_th = _resolveComponent("b-th");
  const _component_hug_value = _resolveComponent("hug-value");
  const _component_b_tr = _resolveComponent("b-tr");
  const _component_wrap_with_popover = _resolveComponent("wrap-with-popover");
  const _component_flex_row = _resolveComponent("flex-row");
  const _component_AppIcon = _resolveComponent("AppIcon");
  const _component_date_value = _resolveComponent("date-value");
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_percentage_value = _resolveComponent("percentage-value");
  const _component_evolution_value = _resolveComponent("evolution-value");
  const _component_slot_with_evolution_value = _resolveComponent("slot-with-evolution-value");
  const _component_overlap_bar_value = _resolveComponent("overlap-bar-value");
  const _component_image_element = _resolveComponent("image-element");
  const _component_wrap_with_copy = _resolveComponent("wrap-with-copy");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_number_value = _resolveComponent("number-value");
  const _component_bar_with_value = _resolveComponent("bar-with-value");
  const _component_dot_element = _resolveComponent("dot-element");
  const _component_variable_styled_bar = _resolveComponent("variable-styled-bar");
  const _component_layer_bars = _resolveComponent("layer-bars");
  const _component_b_table_lite = _resolveComponent("b-table-lite");
  const _component_wrap_table_with_show_more = _resolveComponent("wrap-table-with-show-more");
  const _component_table_with_title = _resolveComponent("table-with-title");
  return _openBlock(), _createBlock(_component_table_with_title, {
    title: "Evolution",
    class: "opportunities-period-table",
    noDownload: "",
    fields: $options.fields,
    loading: $props.loading
  }, {
    "period-selector": _withCtx(() => [_renderSlot(_ctx.$slots, "period-selector")]),
    default: _withCtx(() => [_createVNode(_component_wrap_table_with_show_more, {
      modelValue: $options.period_pager,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.period_pager = $event),
      period: _ctx.period
    }, {
      default: _withCtx(() => [_createVNode(_component_b_table_lite, {
        class: "lite-table lite-table-hoverable period-table performance-table",
        fields: $options.fields,
        bordered: "",
        responsive: "",
        fixed: "",
        items: $options.items,
        "sticky-header": true,
        tbodyTrClass: item => `item-row ${$options.highlightBasedOnGranularity(item) ? 'scrapping-change-highlight' : ''} ${this.handleRowClass(item, this.items)}`,
        "no-border-collapse": "",
        onRowClicked: $options.handleRowClick,
        fieldColumnClass: field => $options.getThClass(field),
        style: _normalizeStyle($options.tableStyle)
      }, {
        "thead-top": _withCtx(() => [_createVNode(_component_b_tr, {
          class: "headers"
        }, {
          default: _withCtx(() => [_createVNode(_component_b_th, {
            colspan: "1",
            style: {
              borderRight: 'none'
            }
          }), _createVNode(_component_b_th, {
            colspan: "1",
            "sticky-column": "",
            class: "right_shadow"
          }), _createVNode(_component_b_th, {
            colspan: "2",
            style: {
              color: '#9447FF',
              borderBottom: '1px solid #9447FF'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_hug_value, null, {
              default: _withCtx(() => [_createTextVNode("Global")]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_b_th, {
            colspan: "3",
            style: {
              color: '#22863D',
              borderBottom: '1px solid #22863D'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_hug_value, null, {
              default: _withCtx(() => [_createTextVNode("Organic Visibility")]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_b_th, {
            colspan: "2",
            style: {
              color: '#8AB4FF',
              borderBottom: '1px solid #8AB4FF'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_hug_value, null, {
              default: _withCtx(() => [_createTextVNode("PPC Visibility")]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_b_th, {
            colspan: "1",
            style: {
              "border-right": "none"
            }
          }), _createVNode(_component_b_th, {
            colspan: "1",
            "sticky-column": "",
            class: "sf_estimated_opportunity left_shadow"
          })]),
          _: 1
        })]),
        "head(selector)": _withCtx(col => [_createElementVNode("div", {
          innerHTML: col?.label,
          class: "title"
        }, null, 8, _hoisted_1)]),
        "head()": _withCtx(col => [_createVNode(_component_flex_row, {
          id: `default-period-table-${col?.column}`,
          styles: {
            justifyContent: col.field.justify,
            ...col.field.thStyle
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_wrap_with_popover, {
            target: `default-period-table-${col?.column}`
          }, {
            title: _withCtx(() => [_createElementVNode("div", {
              innerHTML: $options.getDescriptionBasedOnKpiKey(col?.column ?? '')?.title
            }, null, 8, _hoisted_2)]),
            content: _withCtx(() => [_createTextVNode(_toDisplayString($options.getDescriptionBasedOnKpiKey(col?.column ?? '')?.detail), 1)]),
            default: _withCtx(() => [_createElementVNode("div", {
              innerHTML: col?.column === 'period_agg' ? $options.getPeriodColumnTitle : col?.label,
              class: "title"
            }, null, 8, _hoisted_3)]),
            _: 2
          }, 1032, ["target"])]),
          _: 2
        }, 1032, ["id", "styles"])]),
        "head(sf_share_of_voice)": _withCtx(col => [_createVNode(_component_flex_row, {
          styles: {
            flexDirection: 'column !important'
          }
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            innerHTML: col?.label,
            style: {
              "padding": "4px"
            },
            class: "title"
          }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.getDescriptionBasedOnKpiKey(col?.column ?? '')?.sublabels, (sublabel, index) => {
            return _openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_wrap_with_popover, null, {
              title: _withCtx(() => [_createElementVNode("div", {
                innerHTML: $options.getDescriptionBasedOnKpiKey(col?.column ?? '')?.title[index]
              }, null, 8, _hoisted_7)]),
              content: _withCtx(() => [_createTextVNode(_toDisplayString($options.getDescriptionBasedOnKpiKey(col?.column ?? '')?.detail[index]), 1)]),
              default: _withCtx(() => [_createElementVNode("div", {
                innerHTML: sublabel,
                class: "title"
              }, null, 8, _hoisted_8)]),
              _: 2
            }, 1024)]);
          }), 256))])]),
          _: 2
        }, 1024)]),
        "cell(selector)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_AppIcon, {
            icon: `zoom-${row.item.selected ? 'out' : 'in'}`,
            color: row.item.selected ? null : '#ADADAD',
            size: 16
          }, null, 8, ["icon", "color"])]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(period_agg)": _withCtx(row => [_createVNode(_component_date_value, {
          value: row.item?.period_agg,
          format: $options.getDateValueFormat,
          styles: {
            justifyContent: 'flex-start',
            ..._ctx.activateDateValueStyles(row)
          },
          loading: $props.loading
        }, null, 8, ["value", "format", "styles", "loading"])]),
        "cell(search_query_volume)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 8
          }, {
            evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`search_query_volume_evol${$data.evolCategory[_ctx.periodCategory]}`]
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`search_query_volume_evol${$data.evolCategory[_ctx.periodCategory]}`],
                color: color,
                charCount: $options.maxCharCount?.percentage?.[`search_query_volume_evol${$data.evolCategory[_ctx.periodCategory]}`],
                showSign: "",
                align: "right",
                tight: ""
              }, null, 8, ["value", "color", "charCount"])]),
              _: 2
            }, 1032, ["value"])]),
            default: _withCtx(() => [_createVNode(_component_currency_value, {
              value: row.item?.search_query_volume,
              loading: $props.loading,
              showSymbol: false,
              align: "right",
              allowPrecisionModification: false,
              charCount: $options.maxCharCount?.currency?.search_query_volume,
              precision: row.item?.search_query_volume > 1000000 ? 1 : 0
            }, null, 8, ["value", "loading", "charCount", "precision"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(purchases_share)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px 0px 0px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 0
          }, {
            evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`seller_purchase_share_evol${$data.evolCategory[_ctx.periodCategory]}`] * 100
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`seller_purchase_share_evol${$data.evolCategory[_ctx.periodCategory]}`],
                color: color,
                charCount: $options.minMax?.[`seller_purchase_share_evol${$data.evolCategory[_ctx.periodCategory]}`]?.min <= 0.009 ? $options.maxCharCount?.percentage?.[`seller_purchase_share_evol${$data.evolCategory[_ctx.periodCategory]}`] + 2 : $options.maxCharCount?.percentage?.[`seller_purchase_share_evol${$data.evolCategory[_ctx.periodCategory]}`],
                precision: Math.abs(row.item?.[`seller_purchase_share_evol${$data.evolCategory[_ctx.periodCategory]}`]) >= 0.001 && Math.abs(row.item?.[`seller_purchase_share_evol${$data.evolCategory[_ctx.periodCategory]}`]) <= 0.009 ? 1 : 0,
                showSign: "",
                pp: "",
                tight: ""
              }, null, 8, ["value", "color", "charCount", "precision"])]),
              _: 2
            }, 1032, ["value"])]),
            default: _withCtx(() => [_createVNode(_component_overlap_bar_value, {
              value: row.item?.seller_purchase_share,
              background: "",
              borderColor: "#FFE5D6",
              min: $options.minMax?.seller_purchase_share?.min,
              max: $options.minMax?.seller_purchase_share?.max,
              loading: $props.loading,
              align: "left",
              styles: {
                padding: 0
              },
              barStyles: {
                borderLeft: 'none',
                borderRadius: '0px',
                height: '28px',
                background: '#FFE5D6'
              },
              class: "purchase-share-bar"
            }, {
              default: _withCtx(() => [_createVNode(_component_percentage_value, {
                value: row.item?.seller_purchase_share,
                charCount: $options.minMax?.seller_purchase_share?.min < 0.01 ? $options.maxCharCount?.percentage?.seller_purchase_share + 2 : $options.maxCharCount?.percentage?.seller_purchase_share + 1,
                precision: 1,
                tight: ""
              }, null, 8, ["value", "charCount"])]),
              _: 2
            }, 1032, ["value", "min", "max", "loading"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(top_product)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_wrap_with_popover, {
            delay: {
              show: 0,
              hide: 100
            },
            customClass: "sf-opportunities-product-popover"
          }, _createSlots({
            default: _withCtx(() => [_createVNode(_component_image_element, {
              image: row.item?.best_organic_product_image_link,
              width: 23,
              height: 23,
              borderColor: row.item?.best_organic_product_is_own_asin ? '#33B8FF' : '#E3E3E3',
              style: {
                "width": "25px",
                "height": "25px"
              }
            }, null, 8, ["image", "borderColor"])]),
            _: 2
          }, [JSON.parse(row.item?.best_organic_product) ? {
            name: "content",
            fn: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createVNode(_component_image_element, {
              image: JSON.parse(row.item?.best_organic_product)?.image,
              link: JSON.parse(row.item?.best_organic_product)?.link,
              countryCode: $data.country_code_amz_sp_api_marketplace_ids_flipped[$data.amz_sp_api_marketplace_ids_country_domains_flipped[row.item?.best_organic_own_product_sales_channel]],
              width: 38,
              height: 38,
              withFlag: "",
              withOverlay: "",
              borderColor: row.item?.best_organic_product_is_own_asin ? '#33B8FF' : '#E3E3E3',
              style: {
                "width": "40px",
                "height": "40px"
              },
              flagStyle: {
                width: '24px',
                height: '16px',
                aspectRatio: '7/5',
                bottom: '-8px',
                right: '6px'
              }
            }, null, 8, ["image", "link", "countryCode", "borderColor"]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(JSON.parse(row.item?.best_organic_product)?.title), 1), _createVNode(_component_wrap_with_copy, {
              class: "asin"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(JSON.parse(row.item?.best_organic_product)?.asin), 1)]),
              _: 2
            }, 1024)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_currency_value, {
              value: JSON.parse(row.item?.best_organic_product)?.price_value,
              currency: JSON.parse(row.item?.best_organic_product)?.price_currency
            }, null, 8, ["value", "currency"])]), _createElementVNode("div", _hoisted_15, [_createTextVNode(_toDisplayString(JSON.parse(row.item?.best_organic_product)?.rating) + " ", 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.round(JSON.parse(row.item?.best_organic_product)?.rating ?? 0), n => {
              return _openBlock(), _createBlock(_component_app_icon, {
                icon: "star-fill",
                color: "#F9CA51",
                size: 12,
                key: n
              });
            }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(5 - Math.round(JSON.parse(row.item?.best_organic_product)?.rating ?? 0), n => {
              return _openBlock(), _createBlock(_component_app_icon, {
                icon: "star-fill",
                color: "#E3E3E3",
                size: 12,
                key: n
              });
            }), 128)), _createTextVNode(" ("), _createVNode(_component_currency_value, {
              value: JSON.parse(row.item?.best_organic_own_product)?.reviews,
              showSymbol: false,
              allowPrecisionModification: false,
              tight: ""
            }, null, 8, ["value"]), _createTextVNode(") ")])])])])]),
            key: "0"
          } : undefined]), 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(sf_share_of_voice)": _withCtx(row => [_createVNode(_component_flex_row, null, {
          default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(['top_1_share_of_voice', 'top_3_share_of_voice', 'top_10_share_of_voice'], element => {
            return _createVNode(_component_hug_value, {
              loading: $props.loading,
              style: {
                "padding": "0px 8px"
              },
              class: "sf-share-of-voice-subelts"
            }, {
              default: _withCtx(() => [_createVNode(_component_wrap_with_popover, {
                delay: {
                  show: 0,
                  hide: 100
                },
                customClass: "sf-opportunities-product-popover",
                boundary: "window"
              }, _createSlots({
                default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
                  gap: 0
                }, {
                  evolution: _withCtx(() => [_createVNode(_component_percentage_value, {
                    value: row.item?.[element],
                    charCount: $options.maxCharCount?.percentage?.[element],
                    align: "right",
                    tight: ""
                  }, null, 8, ["value", "charCount"])]),
                  default: _withCtx(() => [_createVNode(_component_bar_with_value, {
                    value: row.item?.[element],
                    min: 0,
                    color: "#22863D",
                    max: 1,
                    loading: $props.loading,
                    tight: ""
                  }, {
                    "bar-append": _withCtx(() => [_hoisted_23]),
                    _: 2
                  }, 1032, ["value", "loading"])]),
                  _: 2
                }, 1024)]),
                _: 2
              }, [row.item?.[element] ? {
                name: "content",
                fn: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createTextVNode(_toDisplayString('ASINS Ranked Top') + " " + _toDisplayString({
                  'top_1_share_of_voice': 1,
                  'top_3_share_of_voice': 3,
                  'top_10_share_of_voice': 10
                }[element]) + " ", 1), _hoisted_18]), _createElementVNode("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(row.item?.[`asins_organic_detail_${{
                  'top_1_share_of_voice': 'top_1',
                  'top_3_share_of_voice': 'top_3',
                  'top_10_share_of_voice': 'top_10'
                }[element]}`]), elt => {
                  return _openBlock(), _createElementBlock("div", {
                    class: "body-row",
                    key: element
                  }, [_createElementVNode("div", _hoisted_20, [_createVNode(_component_image_element, {
                    image: elt?.product_image_link,
                    link: elt?.product_link,
                    withOverlay: "",
                    width: 26,
                    height: 26,
                    borderColor: elt?.is_own ? '#669EFF' : '#FF8F94',
                    style: {
                      "width": "28px",
                      "height": "28px",
                      "align-self": "flex-start"
                    }
                  }, null, 8, ["image", "link", "borderColor"]), _createElementVNode("div", _hoisted_21, [_createTextVNode(_toDisplayString($options.truncateString(elt?.product_title, 60)) + " ", 1), _createElementVNode("span", _hoisted_22, _toDisplayString(elt?.asin), 1)])]), _createVNode(_component_percentage_value, {
                    value: elt?.frequency,
                    tight: "",
                    class: "attribute",
                    align: "right"
                  }, null, 8, ["value"]), _createVNode(_component_number_value, {
                    value: elt?.best_organic_position,
                    tight: "",
                    prepend: "#",
                    class: "attribute",
                    align: "right"
                  }, null, 8, ["value"])]);
                }), 128))])])]),
                key: "0"
              } : undefined]), 1024)]),
              _: 2
            }, 1032, ["loading"]);
          }), 64))]),
          _: 2
        }, 1024)]),
        "cell(sf_best_position)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_flex_row, {
            gap: 6,
            style: {
              "justify-content": "space-between",
              "align-items": "center",
              "width": "100%"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_number_value, {
              value: row.item?.best_organic_position,
              precision: 0,
              tight: "",
              prepend: "#"
            }, null, 8, ["value"]), _createVNode(_component_wrap_with_popover, {
              delay: {
                show: 0,
                hide: 100
              },
              customClass: "sf-opportunities-product-popover"
            }, _createSlots({
              default: _withCtx(() => [_createVNode(_component_image_element, {
                image: row.item?.best_organic_own_product_image_link,
                width: 23,
                height: 23,
                style: {
                  "width": "25px",
                  "height": "25px"
                }
              }, null, 8, ["image"])]),
              _: 2
            }, [JSON.parse(row.item?.best_organic_own_product) ? {
              name: "content",
              fn: _withCtx(() => [_createElementVNode("div", _hoisted_24, [_createVNode(_component_image_element, {
                image: JSON.parse(row.item?.best_organic_own_product)?.image,
                link: JSON.parse(row.item?.best_organic_own_product)?.link,
                countryCode: $data.country_code_amz_sp_api_marketplace_ids_flipped[$data.amz_sp_api_marketplace_ids_country_domains_flipped[JSON.parse(row.item?.best_organic_own_product)?.sales_channel]],
                width: 38,
                height: 38,
                withFlag: "",
                withOverlay: "",
                style: {
                  "width": "40px",
                  "height": "40px"
                },
                flagStyle: {
                  width: '24px',
                  height: '16px',
                  aspectRatio: '7/5',
                  bottom: '-8px',
                  right: '6px'
                }
              }, null, 8, ["image", "link", "countryCode"]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, _toDisplayString(JSON.parse(row.item?.best_organic_own_product)?.title), 1), _createVNode(_component_wrap_with_copy, {
                class: "asin"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(JSON.parse(row.item?.best_organic_own_product)?.asin), 1)]),
                _: 2
              }, 1024)]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createVNode(_component_currency_value, {
                value: JSON.parse(row.item?.best_organic_own_product)?.price_value,
                currency: JSON.parse(row.item?.best_organic_own_product)?.price_currency
              }, null, 8, ["value", "currency"])]), _createElementVNode("div", _hoisted_30, [_createTextVNode(_toDisplayString(JSON.parse(row.item?.best_organic_own_product)?.rating) + " ", 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.round(JSON.parse(row.item?.best_organic_own_product)?.rating ?? 0), n => {
                return _openBlock(), _createBlock(_component_app_icon, {
                  icon: "star-fill",
                  color: "#F9CA51",
                  size: 12,
                  key: n
                });
              }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(5 - Math.round(JSON.parse(row.item?.best_organic_own_product)?.rating ?? 0), n => {
                return _openBlock(), _createBlock(_component_app_icon, {
                  icon: "star-fill",
                  color: "#E3E3E3",
                  size: 12,
                  key: n
                });
              }), 128)), _createTextVNode(" ("), _createVNode(_component_currency_value, {
                value: JSON.parse(row.item?.best_organic_own_product)?.reviews,
                showSymbol: false,
                allowPrecisionModification: false,
                tight: ""
              }, null, 8, ["value"]), _createTextVNode(") ")])])])])]),
              key: "0"
            } : undefined]), 1024), _createVNode(_component_number_value, {
              value: row.item?.[`best_organic_position_evol${$data.evolCategory[_ctx.periodCategory]}`],
              color: row.item?.[`best_organic_position_evol${$data.evolCategory[_ctx.periodCategory]}`] < 0 ? '#E7747A' : '#22863D',
              charCount: $options.maxCharCount?.number?.[`best_organic_position_evol${$data.evolCategory[_ctx.periodCategory]}`],
              showSign: "",
              align: "right",
              tight: ""
            }, null, 8, ["value", "color", "charCount"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(sov_sponsored)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 0
          }, {
            evolution: _withCtx(() => [_createVNode(_component_percentage_value, {
              value: row.item?.share_of_voice_sponsored,
              charCount: $options.maxCharCount?.percentage?.share_of_voice_sponsored,
              align: "right",
              tight: ""
            }, null, 8, ["value", "charCount"])]),
            default: _withCtx(() => [_createVNode(_component_bar_with_value, {
              value: row.item?.share_of_voice_sponsored,
              min: 0,
              color: "#8AB4FF",
              max: 1,
              loading: $props.loading,
              tight: ""
            }, {
              "bar-append": _withCtx(() => [_hoisted_31]),
              _: 2
            }, 1032, ["value", "loading"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(no_impressions_per_search)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px"
          },
          class: "sf-impressions-per-search"
        }, {
          default: _withCtx(() => [_createVNode(_component_wrap_with_popover, {
            delay: {
              show: 0,
              hide: 100
            },
            customClass: "sf-opportunities-product-popover"
          }, _createSlots({
            default: _withCtx(() => [_createVNode(_component_flex_row, {
              gap: 2,
              styles: {
                alignSelf: 'stretch',
                width: '100%'
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_overlap_bar_value, {
                value: row.item?.sb_impressions_per_search,
                background: "",
                borderColor: "#E3D4F3",
                min: Math.min($options.minMax?.sb_impressions_per_search?.min, $options.minMax?.sp_impressions_per_search?.min),
                max: Math.max($options.minMax?.sb_impressions_per_search?.max, $options.minMax?.sp_impressions_per_search?.max),
                loading: $props.loading,
                align: "right",
                styles: {
                  padding: 0,
                  width: '50%'
                },
                barStyles: {
                  borderLeft: 'none',
                  borderRadius: '4px',
                  height: '22px',
                  background: '#E3D4F3'
                },
                class: "purchase-share-bar"
              }, {
                default: _withCtx(() => [_createVNode(_component_number_value, {
                  value: row.item?.sb_impressions_per_search,
                  precision: 1,
                  tight: "",
                  append: "x"
                }, null, 8, ["value"])]),
                _: 2
              }, 1032, ["value", "min", "max", "loading"]), _createVNode(_component_overlap_bar_value, {
                value: row.item?.sp_impressions_per_search,
                background: "",
                borderColor: "#EDF5FF",
                min: Math.min($options.minMax?.sp_impressions_per_search?.min, $options.minMax?.sb_impressions_per_search?.min),
                max: Math.max($options.minMax?.sp_impressions_per_search?.max, $options.minMax?.sb_impressions_per_search?.max),
                loading: $props.loading,
                align: "left",
                styles: {
                  padding: 0,
                  width: '50%'
                },
                barStyles: {
                  borderLeft: 'none',
                  borderRadius: '4px',
                  height: '22px',
                  background: '#EDF5FF'
                },
                class: "purchase-share-bar"
              }, {
                default: _withCtx(() => [_createVNode(_component_number_value, {
                  value: row.item?.sp_impressions_per_search,
                  precision: 1,
                  tight: "",
                  append: "x",
                  color: "#2172E1"
                }, null, 8, ["value"])]),
                _: 2
              }, 1032, ["value", "min", "max", "loading"])]),
              _: 2
            }, 1024)]),
            _: 2
          }, [!_ctx.products.selectedValues?.length ? {
            name: "content",
            fn: _withCtx(() => [_createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_hoisted_34, _createVNode(_component_date_value, {
              value: row.item?.period_agg,
              format: $options.getDateValueFormat,
              styles: {
                justifyContent: 'flex-start',
                ..._ctx.activateDateValueStyles(row)
              },
              loading: $props.loading,
              class: "date"
            }, null, 8, ["value", "format", "styles", "loading"])]), _createElementVNode("div", _hoisted_35, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList([{
              key: 'Sponsored Brand',
              color: '#E3D4F3',
              impressions_per_search: row.item?.sb_impressions_per_search,
              impressions: row.item?.sb_impressions
            }, {
              key: 'Sponsored Product',
              color: '#8AB4FF',
              impressions_per_search: row.item?.sp_impressions_per_search,
              impressions: row.item?.sp_impressions
            }], element => {
              return _openBlock(), _createElementBlock("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createVNode(_component_dot_element, {
                color: element.color,
                size: 10
              }, null, 8, ["color"]), _createTextVNode(" " + _toDisplayString(element.key), 1)]), _createElementVNode("div", _hoisted_38, [_createVNode(_component_number_value, {
                value: element.impressions_per_search,
                precision: 1,
                tight: "",
                append: "x",
                class: "value1",
                align: "right",
                charCount: Math.max($options.maxCharCount?.number?.sb_impressions_per_search, $options.maxCharCount?.number?.sp_impressions_per_search) + 3
              }, null, 8, ["value", "charCount"]), _createVNode(_component_currency_value, {
                value: element.impressions,
                tight: "",
                class: "value2",
                showSymbol: false,
                allowPrecisionModification: false,
                charCount: Math.max($options.maxCharCount?.currency?.sb_impressions, $options.maxCharCount?.currency?.sp_impressions)
              }, null, 8, ["value", "charCount"])])]);
            }), 256))])])]),
            key: "0"
          } : undefined]), 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(sf_click_share)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px"
          },
          class: "sf-click-share"
        }, {
          default: _withCtx(() => [_createVNode(_component_wrap_with_popover, {
            delay: {
              show: 0,
              hide: 100
            },
            customClass: "sf-opportunities-product-popover"
          }, _createSlots({
            default: _withCtx(() => [_createVNode(_component_flex_row, {
              styles: {
                flexDirection: 'column !important',
                position: 'relative',
                maxHeight: '32px',
                gap: '4px',
                width: '100%'
              }
            }, {
              default: _withCtx(() => [_createElementVNode("section", _hoisted_46, [_withDirectives(_createVNode(_component_percentage_value, {
                ref: "oneCurrency",
                loading: $props.loading,
                class: "little-percentage",
                value: row.item?.sp_click_ratio,
                color: "#8AB4FF",
                style: {
                  "left": "0%"
                }
              }, null, 8, ["loading", "value"]), [[_vShow, parseFloat(row.item?.sp_click_ratio) > 0.13]]), _withDirectives(_createVNode(_component_percentage_value, {
                ref: "twoCurrency",
                loading: $props.loading,
                class: "little-percentage",
                value: row.item?.sb_click_ratio,
                color: "#E3D4F3",
                style: _normalizeStyle({
                  left: `${parseFloat(row.item?.sp_click_ratio) * 100}%`
                })
              }, null, 8, ["loading", "value", "style"]), [[_vShow, parseFloat(row.item?.sb_click_ratio) > 0.13 && parseFloat(row.item?.sp_click_ratio) <= 0.9]]), _withDirectives(_createVNode(_component_percentage_value, {
                ref: "threeCurrency",
                loading: $props.loading,
                class: "little-percentage",
                value: row.item?.organic_click_ratio,
                color: "#22863D",
                style: _normalizeStyle({
                  left: `${(parseFloat(row.item?.sb_click_ratio) + parseFloat(row.item?.sp_click_ratio)) * 100}%`
                })
              }, null, 8, ["loading", "value", "style"]), [[_vShow, parseFloat(row.item?.organic_click_ratio) > 0.13 && parseFloat(row.item?.sp_click_ratio) <= 0.9]])]), _createVNode(_component_layer_bars, null, {
                default: _withCtx(() => [_createVNode(_component_variable_styled_bar, {
                  ref: "three",
                  style: {
                    "--bar-radius": "0 4px 4px 0"
                  },
                  value: parseFloat(row.item?.organic_click_ratio) + parseFloat(row.item?.sb_click_ratio) + parseFloat(row.item?.sp_click_ratio),
                  max: 1,
                  min: 0,
                  color: "#22863D",
                  height: 6
                }, null, 8, ["value"]), _createVNode(_component_variable_styled_bar, {
                  ref: "two",
                  style: {
                    "--bar-radius": "0px"
                  },
                  value: parseFloat(row.item?.sb_click_ratio) + parseFloat(row.item?.sp_click_ratio),
                  max: 1,
                  min: 0,
                  color: "#E3D4F3",
                  height: 6
                }, null, 8, ["value"]), _createVNode(_component_variable_styled_bar, {
                  ref: "one",
                  style: {
                    "--bar-radius": "4px 0 0 4px"
                  },
                  value: parseFloat(row.item?.sp_click_ratio),
                  max: 1,
                  min: 0,
                  color: "#8AB4FF",
                  height: 6
                }, null, 8, ["value"])]),
                _: 2
              }, 1024)]),
              _: 2
            }, 1024)]),
            _: 2
          }, [!_ctx.products.selectedValues?.length ? {
            name: "content",
            fn: _withCtx(() => [_createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_hoisted_41, _createVNode(_component_currency_value, {
              value: parseFloat(row.item?.organic_clicks) + parseFloat(row.item?.sb_clicks) + parseFloat(row.item?.sp_clicks),
              tight: "",
              class: "date",
              showSymbol: false,
              allowPrecisionModification: false
            }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_42, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList([{
              key: 'Sponsored Product',
              color: '#8AB4FF',
              ratio: row.item?.sp_click_ratio,
              clicks: row.item?.sp_clicks
            }, {
              key: 'Sponsored Brand',
              color: '#E3D4F3',
              ratio: row.item?.sb_click_ratio,
              clicks: row.item?.sb_clicks
            }, {
              key: 'Organic',
              color: '#22863D',
              ratio: row.item?.organic_click_ratio,
              clicks: row.item?.organic_clicks
            }], element => {
              return _openBlock(), _createElementBlock("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_createVNode(_component_dot_element, {
                color: element.color,
                size: 10
              }, null, 8, ["color"]), _createTextVNode(" " + _toDisplayString(element.key), 1)]), _createElementVNode("div", _hoisted_45, [_createVNode(_component_currency_value, {
                value: element.clicks,
                showSymbol: false,
                allowPrecisionModification: false,
                tight: "",
                class: "value1",
                align: "right",
                charCount: Math.max($options.maxCharCount?.currency?.sp_clicks, $options.maxCharCount?.currency?.sb_clicks, $options.maxCharCount?.currency?.organic_clicks)
              }, null, 8, ["value", "charCount"]), _createVNode(_component_percentage_value, {
                value: element.ratio,
                tight: "",
                class: "value2",
                charCount: Math.max($options.maxCharCount?.percentage?.sp_click_ratio, $options.maxCharCount?.percentage?.sb_click_ratio, $options.maxCharCount?.percentage?.organic_click_ratio)
              }, null, 8, ["value", "charCount"])])]);
            }), 256))])])]),
            key: "0"
          } : undefined]), 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(estimated_opportunity)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_currency_value, {
            value: row.item?.missed_opportunities,
            color: "#4D4D4D",
            style: {
              "font-size": "14px"
            },
            showSign: "",
            align: "right"
          }, null, 8, ["value"])]),
          _: 2
        }, 1032, ["loading"])]),
        _: 1
      }, 8, ["fields", "items", "tbodyTrClass", "onRowClicked", "fieldColumnClass", "style"])]),
      _: 1
    }, 8, ["modelValue", "period"])]),
    _: 3
  }, 8, ["fields", "loading"]);
}